"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* The broadcast template renderer. It mirrors the Go renderer in
 * apps/backend/pkg/bloom/command/broadcast_template.go; both are checked
 * against apps/backend/pkg/bloom/command/testdata/broadcast_template_cases.json,
 * so change them together. */

var _broadcastCampaign = require('shared/validation/broadcastCampaign');

const TOKEN_PATTERN = /\{\{([^{}]*)\}\}/g
const NAME_PATTERN = /^[A-Za-z0-9_]+$/
// ASCII-only, matching the Go renderer's trim set.
const EDGE_SPACE = /^[ \t\n\r\f\v]+|[ \t\n\r\f\v]+$/g

const trimSpace = (value) => value.replace(EDGE_SPACE, '')

const valueOf = (values, name) =>
  values && Object.prototype.hasOwnProperty.call(values, name) ? _nullishCoalesce(values[name], () => ( '')) : ''



/* The variables every message may use without declaring them, filled from
 * the recipient's patient record when the message renders (Rev 24 M1). No
 * campaign can declare them, so a CSV column can't map to them as variables. */
 const BUILT_IN_TEMPLATE_VARIABLES = [
  { Name: 'first_name', Label: 'First name' },
  { Name: 'last_name', Label: 'Last name' },
] ; exports.BUILT_IN_TEMPLATE_VARIABLES = BUILT_IN_TEMPLATE_VARIABLES

 const isBuiltInVariable = (name) =>
  exports.BUILT_IN_TEMPLATE_VARIABLES.some(variable => variable.Name === name); exports.isBuiltInVariable = isBuiltInVariable

/* "first name" for first_name, in a sentence; any other name as it is. */
 const builtInLabel = (name) =>
  _nullishCoalesce(_optionalChain([exports.BUILT_IN_TEMPLATE_VARIABLES, 'access', _ => _.find, 'call', _2 => _2(variable => variable.Name === name), 'optionalAccess', _3 => _3.Label, 'access', _4 => _4.toLowerCase, 'call', _5 => _5()]), () => ( name)); exports.builtInLabel = builtInLabel

/* The recipient's patient record, for the built-in names. */











/* Substitutes {{name}} and {{name | fallback}} tokens. A missing or blank
 * value uses the fallback; without one the token stays in place and is
 * reported as unresolved. Values are inserted literally, never re-rendered. */
 const renderTemplate = (template, values) =>
  renderWithDefaults(template, values, null); exports.renderTemplate = renderTemplate

/* renderTemplate with each variable's default, used after the token's own
 * fallback: value, then fallback, then default (Rev 31 B1). A blank default
 * is no default. */
const renderWithDefaults = (
  template,
  values,
  defaults,
) => {
  let rendered = ''
  let last = 0
  const unresolved = []
  for (const match of template.matchAll(TOKEN_PATTERN)) {
    const index = _nullishCoalesce(match.index, () => ( 0))
    const token = match[0]
    const inner = _nullishCoalesce(match[1], () => ( ''))
    const pipe = inner.indexOf('|')
    const name = trimSpace(pipe < 0 ? inner : inner.slice(0, pipe))
    const value = valueOf(values, name)
    rendered += template.slice(last, index)
    if (!NAME_PATTERN.test(name)) {
      rendered += token
      unresolved.push(name)
    } else if (trimSpace(value) !== '') {
      rendered += value
    } else if (pipe >= 0) {
      rendered += trimSpace(inner.slice(pipe + 1))
    } else if (trimSpace(valueOf(defaults, name)) !== '') {
      rendered += valueOf(defaults, name)
    } else {
      rendered += token
      unresolved.push(name)
    }
    last = index + token.length
  }
  rendered += template.slice(last)
  return { rendered, unresolved }
}

/* Length in Unicode code points, as the backend counts it. */
 const renderLength = (value) => [...value].length; exports.renderLength = renderLength

/* Renders a campaign's message for one recipient, using only the values of
 * variables the campaign declares. A recipient without a value gets the
 * token's fallback, else the variable's Default. {{first_name}} and
 * {{last_name}} are the patient's, whatever the values hold; without a
 * patient they are blank. */
 const renderCampaignMessage = (
  campaign,
  values,
  patient,
) => {
  // No prototype, so every accepted slug (even __proto__) is an own key.
  const declared = Object.create(null)
  const defaults = Object.create(null)
  for (const { Name, Default } of _nullishCoalesce(campaign.TemplateFields, () => ( []))) {
    if (values && Object.prototype.hasOwnProperty.call(values, Name)) declared[Name] = valueOf(values, Name)
    if (Default) defaults[Name] = Default
  }
  declared.first_name = _nullishCoalesce(_optionalChain([patient, 'optionalAccess', _6 => _6.FirstName]), () => ( ''))
  declared.last_name = _nullishCoalesce(_optionalChain([patient, 'optionalAccess', _7 => _7.LastName]), () => ( ''))
  return renderWithDefaults(campaign.MessageTemplate, declared, defaults)
}; exports.renderCampaignMessage = renderCampaignMessage

/* The variables a recipient is missing, once each: those the message uses
 * that resolve to nothing. A variable the message doesn't use is never
 * missing, even while the message is blank (Rev 34 S4). Mirrors
 * campaignMissingVariables in apps/backend/pkg/bloom/command/broadcast_template.go. */
 const campaignMissingVariables = (
  campaign,
  values,
  patient,
) => {
  return [...new Set(exports.renderCampaignMessage.call(void 0, campaign, values, patient).unresolved)]
}; exports.campaignMissingVariables = campaignMissingVariables








/* The launch gate's per-recipient check, for previews and filters. The server
 * gate stays authoritative. */
 const checkRecipientRender = (
  campaign,
  values,
  patient,
) => {
  const result = exports.renderCampaignMessage.call(void 0, campaign, values, patient)
  const length = exports.renderLength.call(void 0, result.rendered)
  const limit = _broadcastCampaign.broadcastMessageLimit.call(void 0, campaign.MessageType)
  return { ...result, length, limit, ok: result.unresolved.length === 0 && length <= limit }
}; exports.checkRecipientRender = checkRecipientRender
